import { useEffect } from "react"
import { useFormContext } from "react-hook-form"
import { Lens } from "@hookform/lenses"
import { ReasonForChoosingType } from "@/modules/patients/detail/progress-note/point-of-care/components/fields/reason-for-choosing-type"
import { PointOfCareFormType } from "@/modules/patients/detail/progress-note/point-of-care/schema"
import { type PointOfCareRecord } from "@/modules/patients/detail/progress-note/point-of-care/types"

type TelecareContentProps = {
  pointOfCareFormLens: Lens<PointOfCareFormType>
  isActual: boolean
  medicalPointOfCare: PointOfCareRecord
  actualPointOfCare: PointOfCareRecord
}

export const TelecareContent = ({
  pointOfCareFormLens,
  isActual,
  medicalPointOfCare,
  actualPointOfCare,
}: TelecareContentProps) => {
  const { setValue } = useFormContext<PointOfCareFormType>()

  useEffect(() => {
    setValue("timeToTreatType", null, { shouldDirty: true })
  }, [setValue, medicalPointOfCare, actualPointOfCare])

  return (
    <div className="col-span-2 gap-4">
      {isActual && (
        <ReasonForChoosingType reasonForChoosingTypeLens={pointOfCareFormLens.focus("reasonForChoosingType")} />
      )}
    </div>
  )
}
